import * as angular from "angular";
import {IController} from "angular";

export class selfPickupEditPackagesCtrl implements IController {

  items: any;
  includeBarcode: boolean;
  onAdd: Function;
  onRemove: Function;

  private selectedPackageType: any;
  private count: any;
  private barcode: any;
  private packageTypes: any;

  /* @ngInject */
  constructor(private commonsConstants) {
  }

  $onInit() {
    this.selectedPackageType = undefined;
    this.count = undefined;
    this.barcode = undefined;

    this.packageTypes = this.commonsConstants.packageTypes;
    this.selectedPackageType = this.commonsConstants.packageTypes[0];
  };

  onAddItem(selectedPackageType, count, barcode) {
    const itemToAdd = {
      count: count,
      size: selectedPackageType,
      barcode: barcode,
      labels: [],
      dimensions: {},
      weight: undefined
    };
    this.onAdd({item: itemToAdd});
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupEditPackages', {
    bindings: {
      items: '<',
      includeBarcode: '<?',
      onAdd: '&',
      onRemove: '&'
    },
    template: require('./self-pickup-edit-packages.html').default,
    controller: selfPickupEditPackagesCtrl
  });
